<script>
import Endpoints from '../../../components/common/Endpoints'
import Common from '../../../components/common/Common'
import Request from '../../../components/common/Request'

export default {
    init: payload => {
        const el = document.body
        el.removeAttribute('class')
        $('.modal').modal('hide')
        payload.domain = Endpoints.domain //nao remover, usado para apresentar a foto

        payload.filter()
    },
    methods: {
        filter: function () {
            let state = this
            state.items = []

            if (!this.filters.status) {
                this.filters.status = 'ACTIVE'
            }

            Request.do(
                state,
                'POST',
                Request.getDefaultHeader(state),
                state.filters,
                ` ${Endpoints.companies.listByType}`,
                response => {
                    state.items = response.results
                },
                error => {},
            )
        },
        onChange: function () {},
        getResultValue(result) {
            return `${result.fantasyName || ''} ${result.socialName} ${result.document}`
        },
        submitFilter: function (term) {
            if (!term) return

            this.filters.name = `${term.fantasyName}|${term.socialName}|${term.document}`
            this.filter()
        },
        onChangeName: function (input) {
            let state = this

            this.filters.name = input
            if (input.length < 4) return []
            return new Promise((resolve, reject) => {
                Request.do(
                    state,
                    'GET',
                    Request.getDefaultHeader(state),
                    {},
                    `${Endpoints.companies.suggest}?term=${input}&status=${this.filters.status}&typeService=${this.filters.typeService}`,
                    response => {
                        resolve(response)
                    },
                    error => {
                        //ERROR CALLBACK
                        reject(error)
                    },
                )
            })
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems
        },
        selectItem: function (item) {
            this.$emit('load-item', item)
        },
        getPageNumbers: function () {
            return this.items.length / 10
        },
        fetchData() {
            this.json_data = this.items
            return this.json_data
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    },
}
</script>
